<template>
  <div class="wow-ordering-container">
    <v-data-table :page.sync="pageNo" dense :headers="headers" :items="orderList">
      <template v-slot:item.approvalStatus="{item}">
        <span v-if="orderZsmApprove === item.approvalStatus">{{ zmApproved }}</span>
        <span v-else>{{ item.approvalStatus }}</span>
      </template>
      <template v-slot:item.viewDetails="{ item }">
        <v-btn @click="loadViewAsPerAction('viewDetails', item)" color="accent" small outlined>View Details</v-btn>
      </template>
      <template v-slot:item.placeOrder="{ item }">
        <v-btn @click="loadViewAsPerAction('placeOrder', item)" :disabled="item.approvalStatus !== orderApprovalStatus"
          color="accent" small outlined>Place
          Order</v-btn>
      </template>
      <template v-slot:item.viewGap="{ item }">
        <v-btn @click="loadViewAsPerAction('viewGap', item)" :disabled="checkViewOrderGapStatus(item)" color="accent"
          small outlined>View Gap</v-btn>
      </template>
      <template v-slot:item.orderStatus="{ item }">
        <span v-if="item.approvalStatus === orderApprovalStatus">
          {{ (item.orderStatus === orderPendingStatusConstant) ? overrideOrderStatusPending : item.orderStatus }}
        </span>
        <span v-else> - </span>
      </template>
      <template v-slot:item.gapOrderStatus="{item}">
        {{ item.gapOrderStatus ? item.gapOrderStatus : '-' }}
      </template>
    </v-data-table>
    <wow-dialog :fullscreen="true" :title="orderDialogTitle" v-model="orderDialog" :persistent="true"
      @close="closeOrderDialog">
      <component :is="component" :WOWKIT_ZSM_APPROVED="WOWKIT_ZSM_APPROVED" :WOWKIT_APPROVED="WOWKIT_APPROVED"
        :orderObj='orderObj' @close="closeOrderDialog" @refreshList="refreshListData"/>
    </wow-dialog>
  </div>
</template>
<script>
import CONSTANTS from '@/utils/constants'
import WowDialog from '@/components/Orders/WowKitOrdering/kitComponents/dialog/dialogComponent'
import ViewOrderDetails from '@/components/Orders/WowKitOrdering/kitComponents/order/viewOrderDetails'
import PlaceOrder from '@/components/Orders/WowKitOrdering/kitComponents/order/placeOrder'
import viewGap from '@/components/Orders/WowKitOrdering/kitComponents/order/viewGap'
export default {
  name: 'OrderTable',
  props: {
    initiatedOrderList: {
      type: Array,
      default: () => { }
    },
    WOWKIT_ZSM_APPROVED: {
      type: Boolean,
      default: false
    },
    WOWKIT_APPROVED: {
      type: Boolean,
      default: false
    },
    WOWKIT_MAKER: {
      type: Boolean,
      default: false
    }
  },
  components: {
    WowDialog,
    ViewOrderDetails,
    PlaceOrder,
    viewGap
  },
  data () {
    return {
      headers: [
        { text: 'Order Initiation Date', align: 'center', sortable: true, value: 'createdAt' },
        { text: 'Order Initiated By', align: 'center', sortable: true, value: 'createdBy' },
        { text: 'Center', sortable: true, align: 'center', value: 'franchisee.companyName' },
        { text: 'Approval Status', sortable: false, align: 'center', value: 'approvalStatus' },
        { text: 'View Details', sortable: false, align: 'center', value: 'viewDetails' },
        { text: 'Order Status', sortable: false, align: 'center', value: 'orderStatus' },
        { text: 'View Gap', sortable: false, align: 'center', value: 'viewGap' },
        { text: 'Gap Order Status', sortable: false, align: 'center', value: 'gapOrderStatus' }
      ],
      orderList: [],
      component: null,
      orderDialogTitle: null,
      orderDialog: false,
      orderObj: {},
      orderPendingStatusConstant: CONSTANTS.WOW_KIT_APPROVER.pending,
      zmApproved: CONSTANTS.zmApproved,
      orderZsmApprove: CONSTANTS.WOW_KIT_APPROVER.zmApprove,
      orderApprovalStatus: CONSTANTS.WOW_KIT_APPROVER.approved,
      overrideOrderStatusPending: CONSTANTS.orderStatusOnPlcaed,
      pageNo: 1
    }
  },
  watch: {
    initiatedOrderList: {
      handler: function (newVal) {
        this.pageNo = 1
        this.orderList = newVal
      },
      deep: true
    }
  },
  created () {
    if (this.WOWKIT_MAKER) {
      this.headers.splice(5, 0, { text: 'Place Order', sortable: false, align: 'center', value: 'placeOrder' })
    }
  },
  methods: {
    checkViewOrderGapStatus: function (item) {
      if ((CONSTANTS.ORDER_STATUS.shipped === item.orderStatus) || (CONSTANTS.ORDER_STATUS.delivered === item.orderStatus)) {
        return false
      }
      return true
    },
    loadViewAsPerAction: function (type, orderObj) {
      this.orderDialog = true
      if (type === 'viewDetails') {
        this.orderDialogTitle = 'View Details'
        this.component = 'ViewOrderDetails'
        this.orderObj = orderObj
      } else if (type === 'placeOrder') {
        this.orderDialogTitle = 'Place Order'
        this.component = 'PlaceOrder'
        this.orderObj = orderObj
      } else {
        this.orderDialogTitle = 'View Gap'
        this.component = 'viewGap'
        this.orderObj = orderObj
      }
    },
    closeOrderDialog: function () {
      this.orderDialog = false
      this.orderDialogTitle = null
      this.component = null
    },
    refreshListData: function (status) {
      this.$emit('reloadList', status)
    }
  }
}
</script>
